var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('p',{staticClass:"m-0"},[_vm._v("SCL "+_vm._s(_vm.info)+" · Associação dos Criadores de Gado Jersey do Brasil")])])}
var staticRenderFns = []

export { render, staticRenderFns }